const SideDrawer = ({ menu, selectedPage, setSelectedPage }) => {
  return (
    <>
      <div className="p-2 flex flex-col">
        <button class="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm px-5 py-3 text-center">
          ADD POST
        </button>

        <div className="flex flex-col py-6">
          {menu.map((menu) => (
            <a
              href="#"
              className={`flex items-center space-x-5 hover:bg-neutral-300 transition-all duration-150 p-2 rounded-lg text-lg ${
                selectedPage.title === menu.title ? 'bg-neutral-300' : ''
              }`}
              onClick={() => setSelectedPage(menu)}
            >
              <i className={`fa-solid ${menu.icon}`}></i>
              <p>{menu.title}</p>
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default SideDrawer;
